import { GRAPHITE_COLOR, LG_COLOR } from 'containers/App/constants';
import styled from 'styled-components';

export const NavbarStyles = styled.div`
  box-sizing: border-box;
  height: 100vh;

  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 5%;
  background-color: ${LG_COLOR};
  border-right: 2px solid ${GRAPHITE_COLOR};
  width: 15vw;
  opacity: 1;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  transition:
    width 0.5s linear,
    opacity 0.5s linear 0.25s;

  &::-webkit-scrollbar {
    display: none;
  }

  :not(&[aria-expanded='true']) {
    width: 0px;
    overflow: hidden;
    opacity: 0;
    border: none;
    transition:
      width 0.5s linear,
      opacity 0.25s linear;
  }

  .nav-link {
    all: unset;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    gap: 5px;
    cursor: pointer;
    min-height: 44px;
    padding: 6px 10px;
    box-sizing: border-box;
    color: white;
    font-weight: bold;
    font-size: 1.2rem;

    .nav-icon {
      font-size: 2rem;
    }

    &:hover,
    &[aria-selected='true'] {
      background-color: white;
      color: ${LG_COLOR};
    }
  }
`;
